export default function () {
    return {
        brandData: {
            fontNamePrimary: "Inter",
            displayName: "Turnr",
            homePage: "https://www.ingrid.com/",
            fontSizePrimary: 12,
            colorPrimary: "#57251b",
            colorSecondary: "#e0d4c5",
            orderIdPrefix: "#",
            orderIdText: "ORDER_ID",
            backgroundImage: "https://www.freecodecamp.org/news/content/images/2021/06/w-qjCHPZbeXCQ-unsplash.jpg",
            backgroundImageOpacity: 65,
            backgroundImageBlur: 2,
            logoSrc: "/icons/ingrid/logo-ingrid-black.svg",
            logoHeight: 24,
            productsBundleMock: "DEV_BRAND",
            exchangeActive: true,
            showAllOrders: false,
        },
        brandName: "dev-brand",
    };
}
